<template>
  <a-row :gutter="10" class="new-row">
    <a-col :md="collapsed?0: 5" :sm="24" class="new-col">
      <a-card :bordered="false">
        <!-- 按钮操作区域 -->
        <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
          <a-alert type="info" :showIcon="true">
            <div slot="message">
              {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
              <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
            </div>
          </a-alert>
          <div style="display: flex;margin-top: 10px;">
            <a-input-search v-model="searchAreaValue" style="width:100%;margin-right: 5px;" allowClear :placeholder="$t('请输入区域名称')"/>
            <a-button type="default" @click="collapseAll">{{ $t('折叠') }}</a-button>
          </div>
          <!-- 树-->
          <a-col :md="24" :sm="24" class="new-tree-col">
            <template>
              <a-spin tip="Loading..." :spinning="areaLoading">
                <!--
                <span style="user-select: none">
                  <a-tree
                    class="my-area-select-tree"
                    @select="onSelect"     
                    :selectedKeys="selectedKeys"
                    :treeData="areaTree"
                    :checkStrictly="checkStrictly"
                    :expandedKeys="iExpandedKeys"
                    :autoExpandParent="autoExpandParent"
                    @expand="onExpand">
                    <template slot="title" slot-scope="{title}">
                      <span v-if="title.indexOf(searchAreaValue) > -1">
                        {{title.substr(0, title.indexOf(searchAreaValue))}}
                      <span style="color: #32CD32">{{searchAreaValue}}</span>
                        {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                      </span>
                      <span v-else>{{title}}</span>
                    </template>
                  </a-tree>
                </span>
                -->
                <el-tree
                  class="filter-tree"
                  :data="areaTree"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  :filter-node-method="filterNode"
                  :check-on-click-node="true"
                  :check-strictly="checkStrictly"
                  :highlight-current="true"
                  node-key="id"
                  :current-node-key="currentNodeKey"
                  :default-expanded-keys="iExpandedKeys"
                  @node-click="nodeClick"
                  ref="areaTree">
                </el-tree>
              </a-spin>
            </template>
          </a-col>
        </div>
      </a-card>
    </a-col>
    <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px" class="new-col">
        <a-icon :type="collapsed ? 'caret-right':'caret-left'" 
            @click="collapsed = !collapsed"
            class="area-collapsed"></a-icon>
      <a-card :bordered="false" class="new-table-card">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('表编号')">
                  <a-input :placeholder="$t('请输入表编号')" v-model="queryParam.meterId"></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('运营商')">
                  <a-select :placeholder="$t('请选择运营商')" v-model="queryParam.meterIotType">
                    <a-select-option v-for="(item,value) in netTypeObj" :key="value" :value="value">
                      {{item}}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('表类型')">
                  <a-select v-model="queryParam.meterTypeId" :placeholder="$t('请输入表类型')">
                    <a-select-option v-for="data in userTypeList" :key="data.id" :value="data.id">
                      {{data.mtName}}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <template v-if="toggleSearchStatus">
                
                <!--
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item label="表口径">
                    <a-input placeholder="请输入表口径" v-model="queryParam.mtCaliber"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item label="用户价格名称">
                    <a-select v-model="queryParam.userPriceCode" placeholder="请输入用户价格名称">
                      <a-select-option v-for="(data,index) in userPriceCode" :key="data.id" :value="data.id">
                        {{data.wtName}}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item label="用户价格名称">
                    <a-input placeholder="请输入用户价格名称" v-model="queryParam.userPriceCode"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item label="用户地址">
                    <a-input placeholder="请输入用户地址" v-model="queryParam.userAddr"></a-input>
                  </a-form-item>
                </a-col> -->
                <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item label="水表地址">
                    <a-input placeholder="请输入水表地址" v-model="queryParam.userMeterAddr"></a-input>
                  </a-form-item>
                </a-col> 
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item label="身份证号">
                    <a-input placeholder="请输入身份证号" v-model="queryParam.userIdNumber"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item label="区域编号">
                    <a-input placeholder="请输入用户区域编号" v-model="queryParam.userAreaId"></a-input>
                  </a-form-item>
                </a-col> -->
                <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item label="区域名称">
                    <a-input placeholder="请输入用户所在区域名称" v-model="queryParam.userAreaName"></a-input>
                  </a-form-item>
                </a-col> -->
                <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item label="用户所在小区名或村庄名">
                    <a-input placeholder="请输入用户所在小区名或村庄名" v-model="queryParam.userCommName"></a-input>
                  </a-form-item>
                </a-col> -->
                <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item label="用户用水状态">
                    <a-input placeholder="请输入用户用水状态" v-model="queryParam.userState"></a-input>
                  </a-form-item>
                </a-col> -->
              </template>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                  <a @click="handleToggleSearch" style="margin-left: 8px">
                    {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                  </a>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operator">
          <!-- <a-button @click="handleAdd(1)" type="primary" icon="plus">新建档案</a-button> -->
          <!-- <a-button @click="handleAdd(2)" type="primary" icon="plus">新增用户信息</a-button> -->
          <!-- <a-button type="primary" icon="download" @click="handleExportXls('meter_userinfo')">导出</a-button> -->
          <a-button type="link" icon="download" @click="handleExportXls($t('批量添加命令模板'))">{{ $t('下载批量添加命令模板') }}</a-button>
          <a-button @click="handleBatchAdd(1)" type="primary" icon="plus">{{ $t('批量添加命令(按区域)') }}</a-button>
          <a-button @click="handleBatchAdd(2)" type="primary" icon="plus">{{ $t('批量添加命令(按表号)') }}</a-button>
          <a-button @click="handleBatchAdd(3)" type="primary" icon="plus">{{ $t('批量添加命令(按Excel表号)') }}</a-button>
        </div>
        <!-- table区域-begin -->
        <div class="table-fixed">
          <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
            <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择') }} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{ $t('项') }}
            <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
          </div>
          <a-table
            ref="table"
            size="middle"
            :scroll="{x:true}"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,onSelect:onTableSelect,onSelectAll:onSelectAll}"
            :components="drag(columns)"
            @change="handleTableChange">
            <span slot="action" slot-scope="text, record">
              <!-- <a @click="showMeterCommandQueue(record)">查询命令队列</a> -->
              <a @click="record.meterType=='WN100'?showMeterCommandQueue(record):showMeterCommandOldQueue(record)">{{ $t('命令队列') }}</a>
              <a-divider type="vertical" />
              <!-- <a @click="debuggingCommands(record)">命令下发</a> -->
              <a @click="handleCommand(record)">{{ $t('命令下发') }}</a>
              <!-- <a-divider type="vertical" /> -->
              <!-- <a @click="debugNewCommand(record)">新协议命令下发</a> -->
              <!-- <a-divider type="vertical" /> -->
              <!-- <a-dropdown>
                <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a @click="handleDetail(record)">详情</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                      <a>删除</a>
                    </a-popconfirm>
                  </a-menu-item>
                </a-menu>
              </a-dropdown> -->
            </span>
          </a-table>
        </div>
        <meter-debuggingCommands-modal ref="debuggingCommandsModal" @ok="debuggingCommandsFormOk"></meter-debuggingCommands-modal>
        <debug-newCommand-modal ref="debugNewCommandModal" @ok="debuggingCommandsFormOk"></debug-newCommand-modal>
        <meter-command-queue-old-modal ref="metrCommandQueueOldModal" @ok="metrCommandQueueOldFormOk"></meter-command-queue-old-modal>
        <meter-command-queue-modal ref="metrCommandQueueModal" @ok="metrCommandQueueFormOk"></meter-command-queue-modal>

        <meter-batchCommandOld-modal ref="debugBatchCommandOldModal" @ok="debuggingCommandsFormOk"></meter-batchCommandOld-modal>
        <meter-batchCommandNew-modal ref="debugBatchCommandNewModal" @ok="debuggingCommandsFormOk"></meter-batchCommandNew-modal>
        <meter-dykj-debuggingCommands-modal ref="dykjDebuggingCommandsModal" @ok="modalFormOk"></meter-dykj-debuggingCommands-modal>
        <meter-batchCommandDykj-modal ref="debugBatchCommandDykjModal" @ok="debuggingCommandsFormOk"></meter-batchCommandDykj-modal>
        <debug-uSCommand-modal ref="debugUSCommandModal" @ok="modalFormOk"></debug-uSCommand-modal>
        <meter-batchCommandUS-modal ref="debugBatchCommandUSModal" @ok="debuggingCommandsFormOk"></meter-batchCommandUS-modal>

        <MeterY10QNDebuggingCommandsModal ref="y10qnDebuggingCommandsModal" @ok="modalFormOk"></MeterY10QNDebuggingCommandsModal>
        <MeterBatchCommandY10QNModal ref="debugBatchCommandY10QNModal" @ok="debuggingCommandsFormOk"></MeterBatchCommandY10QNModal>
        <MeterBatchCommandY17NModal ref="debugBatchCommandY17NModal" @ok="debuggingCommandsFormOk"></MeterBatchCommandY17NModal>
        <MeterBatchCommandY18NModal ref="debugBatchCommandY18NModal" @ok="debuggingCommandsFormOk"></MeterBatchCommandY18NModal>
        <MeterY17NDebuggingCommandsModal ref="y17nDebuggingCommandsModal" @ok="modalFormOk"></MeterY17NDebuggingCommandsModal>
        <MeterY18NDebuggingCommandsModal ref="y18nDebuggingCommandsModal" @ok="modalFormOk"></MeterY18NDebuggingCommandsModal>

        <MeterCommonCommandsModal ref="meterCommonCommandsModal" @ok="modalFormOk"></MeterCommonCommandsModal>
        <MeterBatchCommandCommonModal ref="debugBatchCommandCommonModal" @ok="debuggingCommandsFormOk"></MeterBatchCommandCommonModal>
        <a-modal
          :title="$t('选择批量下发表类型')"
          :visible="visible"
          @ok="handleOk"
          @cancel="handleCancel"
        >
          <div style="height: 400px">
            <a-select style="width: 100%" v-model="batchMtCode" :placeholder="$t('请选择表类型')">
              <a-select-option v-for="data in meterTypeList" :key="data.mtCode" :value="data.mtCode">
                {{data.mtCode}}
              </a-select-option>
            </a-select>
          </div>
        </a-modal>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import MeterDebuggingCommandsModal from './modules/MeterDebuggingCommandsModal'
  import debugNewCommandModal from './modules/debugNewCommandModal'
  import meterCommandQueueOldModal from './modules/meterCommandQueueOldModal'
  import meterCommandQueueModal from './modules/meterCommandQueueModal'
  import MeterBatchCommandOldModal from './modules/MeterBatchCommandOldModal'
  import MeterBatchCommandNewModal from './modules/MeterBatchCommandNewModal'
  import MeterDykjDebuggingCommandsModal from './modules/MeterDykjDebuggingCommandsModal'
  import MeterBatchCommandDykjModal from './modules/MeterBatchCommandDykjModal'
  import debugUSCommandModal from './modules/debugUSCommandModal'
  import MeterBatchCommandUSModal from './modules/MeterBatchCommandUSModal'
  import MeterY10QNDebuggingCommandsModal from './modules/MeterY10QNDebuggingCommandsModal'
  import MeterBatchCommandY10QNModal from './modules/MeterBatchCommandY10QNModal'
  import MeterBatchCommandY17NModal from './modules/MeterBatchCommandY17NModal'
  import MeterBatchCommandY18NModal from './modules/MeterBatchCommandY18NModal'
  import MeterY17NDebuggingCommandsModal from './modules/MeterY17NDebuggingCommandsModal'
  import MeterY18NDebuggingCommandsModal from './modules/MeterY18NDebuggingCommandsModal'
  import MeterBatchCommandCommonModal from './modules/MeterBatchCommandCommonModal'
  import MeterCommonCommandsModal from './modules/MeterCommonCommandsModal'

  import {isUndefined} from'@/utils/validate'
  import { listSize,fileUrl } from '@/utils/util'
  import { getAction } from '@/api/manage'
  import {netTypeObj} from '@/utils/constants/protocolConstant'
  import TableDragResize  from '@/mixins/TableDragResize'

  export default {
    name: 'MeterDebuggingCommandsList',
    mixins:[JeecgListMixin, mixinDevice,AreaChoosetMixin,TableDragResize],
    components: {
      MeterDebuggingCommandsModal,
      debugNewCommandModal,
      meterCommandQueueOldModal,
      meterCommandQueueModal,
      MeterBatchCommandOldModal,
      MeterBatchCommandNewModal,
      MeterDykjDebuggingCommandsModal,
      MeterBatchCommandDykjModal,
      debugUSCommandModal,
      MeterBatchCommandUSModal,
      MeterY10QNDebuggingCommandsModal,
      MeterBatchCommandY10QNModal,
      MeterBatchCommandY17NModal,
      MeterY17NDebuggingCommandsModal,
      MeterY18NDebuggingCommandsModal,
      MeterBatchCommandY18NModal,
      MeterBatchCommandCommonModal,
      MeterCommonCommandsModal
    },
    data () {
      return {
        description: 'meter_userinfo管理页面',
        netTypeObj,
        userTypeList:[],  //表类型
        meterTypeList:[{mtCode: 'WN100',mtName: 'WN100'},{mtCode: 'MN100',mtName: 'MN100'},{mtCode: 'MN100-2D',mtName: 'MN100-2D'},{mtCode: 'W12-N',mtName: 'W12-N'},{mtCode: 'Y10-QN',mtName: 'Y10-QN'},{mtCode: 'Y17-N',mtName: 'Y17-N'},{mtCode: 'Y18-N',mtName: 'Y18-N'},{mtCode: 'Y18-17',mtName: 'Y18-17'}],
        // 表头
        url: {
          list: "/jeecg-charge/meter/meterUserinfo/list",
          exportXlsUrl: "/jeecg-charge/meter/meterUserinfo/exportXls",
          userTypeList:"/jeecg-charge/meter/meterType/list",  //表类型请求地址
          commandModelFileUsr: '/file/common_model.xls'
          
        },
        visible: false,
        batchMtCode: '',
        batchType: '',
        batchRecord: ''
      }
    },
    created() {
      this.$store.commit('SET_LAYOUT_TREE',true)
      this.queryUserTypeList();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns () {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t, r, index) => {
              return parseInt(index)+1;
            }
          },
          // {
          //   title:'区域名称',
          //   align:"center",
          //   dataIndex:'userAreaName',
          //   width:100,
          //   ellipsis: true
          // },
          {
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex:'userName',
            width:150,
            ellipsis: true
          },{
            title: this.$t('用户编号'),
            align:"center",
            // sorter: true,
            dataIndex:'userId',
            width:150,
            ellipsis: true
          },{
            title: this.$t('表编号'),
            align:"center",
            dataIndex:'meterId',
            width:150,
            scopedSlots: { customRender: 'meterId' },
            ellipsis: true
            // sorter: (a, b) => a.meterId - b.meterId,
          },{
            title: this.$t('表类型'),
            align:"center",
            dataIndex:'meterTypeName',
            width:100,
            ellipsis: true
          },
          {
            title: this.$t('用户地址'),
            align:"center",
            dataIndex:'userAddr',
            width: 200,
            ellipsis: true,
            customRender: (t, r, index) => {
              if(r.userAreaName){
                let i = r.userAreaName.indexOf('-');
                return r.userAreaName.slice(i+1,r.userAreaName.length)+'-'+t;
              }else{
                return t
              }
            },
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:200,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      handleCommand(record) {
        if(record.meterType=='WN100') {
          this.debugNewCommand(record);
        }else if(record.meterType=='W12-N') {
          // 超声波水表
          this.debugUSCommand(record);
        }else if(record.meterType=='MN100-2D') {
          this.dykjDebuggingCommands(record);
        }else if(record.meterType=='Y10-QN'){
          this.y10qnDebuggingCommands(record);
        }else if(record.meterType=='Y17-N'){
          this.y17nDebuggingCommands(record);
        }else if(record.meterType == 'Y18-N'){
          this.y18nDebuggingCommands(record);
        }else if(record.meterType=='Y18-17'){
          this.y17nDebuggingCommands(record);
        }else if(record.meterType=='MN100') {
          this.debuggingCommands(record);
        }else {
          // 通用对接的命令
          this.debuggingCommonCommands(record);
        }
      },
      debuggingCommonCommands(record) {
        this.$refs.meterCommonCommandsModal.edit(record)
        this.$refs.meterCommonCommandsModal.title = this.$t('命令下发')
      },
      debuggingCommands(record) {
        this.$refs.debuggingCommandsModal.edit(record)
        this.$refs.debuggingCommandsModal.title = this.$t('命令下发')
        // this.queryUserTypeList(record)
      },
      dykjDebuggingCommands(record) {
        this.$refs.dykjDebuggingCommandsModal.edit(record);
        this.$refs.dykjDebuggingCommandsModal.title = this.$t('命令下发');
      },
      // 新协议远程命令下发
      debugNewCommand(record) {
        this.$refs.debugNewCommandModal.edit(record)
      },
      debugUSCommand(record) {
        this.$refs.debugUSCommandModal.edit(record)
      },
      debugOldBatchCommand(record) {
        this.$refs.debugBatchCommandOldModal.edit(record)
        this.$refs.debugBatchCommandOldModal.title = this.$t('批量命令下发')
      },
      debugDykjBatchCommand(record) {
        this.$refs.debugBatchCommandDykjModal.edit(record)
        this.$refs.debugBatchCommandDykjModal.title = this.$t('批量命令下发')
      },
      debugUSBatchCommand(record) {
        this.$refs.debugBatchCommandUSModal.title=this.$t('批量命令下发')
        this.$refs.debugBatchCommandUSModal.edit(record)
      },
      // 新协议远程命令下发
      debugNewBatchCommand(record) {
        this.$refs.debugBatchCommandNewModal.title= this.$t("批量命令下发")
        this.$refs.debugBatchCommandNewModal.edit(record)
      },
      debugY10QNBatchCommand(record){
        this.$refs.debugBatchCommandY10QNModal.title=this.$t('批量命令下发')
        this.$refs.debugBatchCommandY10QNModal.edit(record)
      },
      debugY17NBatchCommand(record){
        this.$refs.debugBatchCommandY17NModal.title=this.$t('批量命令下发')
        this.$refs.debugBatchCommandY17NModal.edit(record)
      },
      debugY18NBatchCommand(record){
        this.$refs.debugBatchCommandY18NModal.title=this.$t('批量命令下发')
        this.$refs.debugBatchCommandY18NModal.edit(record)
      },
      y10qnDebuggingCommands(record) {
        // 旌旗水表
        this.$refs.y10qnDebuggingCommandsModal.edit(record);
        this.$refs.y10qnDebuggingCommandsModal.title = this.$t('命令下发');
      },
      y17nDebuggingCommands(record) {
        // 三川水表
        this.$refs.y17nDebuggingCommandsModal.edit(record);
        this.$refs.y17nDebuggingCommandsModal.title = this.$t('命令下发');
      },
      y18nDebuggingCommands(record){
        this.$refs.y18nDebuggingCommandsModal.edit(record);
        this.$refs.y18nDebuggingCommandsModal.title = this.$t('命令下发');
      },
      debugCommonBatchCommand(record){
        this.$refs.debugBatchCommandCommonModal.title=this.$t('批量命令下发')
        this.$refs.debugBatchCommandCommonModal.edit(record)
      },
      debuggingCommandsFormOk() {
        this.loadData();
      },
      metrCommandQueueFormOk() {
        this.loadData();
      },
      metrCommandQueueOldFormOk() {
        this.loadData();
      },
      showMeterCommandOldQueue(record) {
        console.log("打开就协议命令modal")
        this.$refs.metrCommandQueueOldModal.edit(record)
      },
      showMeterCommandQueue(record) {
        this.$refs.metrCommandQueueModal.edit(record)
      },
      queryUserTypeList() {   //表类型请求
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userTypeList, params).then((res) => {
          if(res.success){
            this.userTypeList = res.result.records;
            console.log(this.userTypeList);
          }
        }) 
      },
      handleCancel() {
        this.visible = false;
      },
      // type为1表示按照区域批量下发命令为2表示按照表编号批量下发命令，0表示单个下发命令
      handleOk() {
        if(this.batchMtCode === ''||this.batchMtCode === null) {
          this.$message.error(this.$t("请先选择批量下发命令的表类型"))
          return
        }
        this.visible = false
        this.handleMeterTypeSubmit({...this.batchRecord,mtCodeName:this. batchMtCode},this.batchMtCode)
      },
      handleMeterTypeSubmit(record,mtCode) {
        console.log("lalala")

        if(mtCode === 'WN100') {
          // 新协议
          this.debugNewBatchCommand(record)
        }else if(mtCode === 'W12-N'){
          this.debugUSBatchCommand(record)
        }else if(mtCode === 'MN100') {
          // 老协议
          this.debugOldBatchCommand(record)
        }else if(mtCode === 'MN100-2D') {
          // 端云科技大口径水表
          this.debugDykjBatchCommand(record)
        }else if(mtCode === 'Y10-QN') {
          this.debugY10QNBatchCommand(record)
        }else if(mtCode === 'Y17-N') {
          this.debugY17NBatchCommand(record)
        }else if(mtCode === 'Y18-N') {
          this.debugY18NBatchCommand(record)
        }else {
          // 通用接口对接
          this.debugCommonBatchCommand(record)
        }
      },
      // 批量添加命令
      handleBatchAdd(type) {
        this.batchType = type
        let record = {batchType: this.batchType}
        if(type === 1||type == 3) {
          // 按区域
          this.batchRecord = record
          this.visible = true
        }else if(type === 2) {
          // 按表号
          if(this.selectionRows.length<1){
            this.$message.error(this.$t("请先选择需要批量发送命令的表号"))
            return
          }else{
            let meterIdList = []
            let mtCode = ''
            for(let i = 0;i<this.selectionRows.length;i++) {
              if(i === 0) {
                mtCode = this.selectionRows[0].meterType
              }else{
                if(mtCode !== this.selectionRows[i].meterType) {
                  this.$message.error(this.$t("选择的批量下发的表类型不一致不能操作，请重新选择同一表类型的表具信息"))
                  return
                }
              }
              meterIdList.push(this.selectionRows[i].meterId)
            }
            record.meterIdList = meterIdList.join(',')
            this.batchRecord = record
            console.log("啦啦")
            this.handleMeterTypeSubmit({...this.batchRecord,mtCodeName:mtCode},this.selectionRows[0].meterType)
          }
        }
        
      },
      handleExportXls(fileName){
        if(!fileName || typeof fileName != "string"){
          fileName = this.$t("导出文件")
        }
        let url = `${fileUrl}${this.url.commandModelFileUsr}`
          let link = document.createElement('a')
          link.style.display = 'none'
            link.href = url
            link.setAttribute('download', fileName+'.xls')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
      },
    }
  }
</script>
<style scoped>
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>